import { observer } from "mobx-react-lite"
import { useProposalsEditDetailsStore } from "./ProposalsEditDetailsStore"
import AutocompleteSingleNonClearable from "reusable/mui/auto-complete/AutocompleteSingleNonClearable"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import DatePicker from "reusable/mui/date-pickers/DatePicker"

export default observer(function ProposalsEditDetailsDueDate() {
   return (
      <>
         <Typography variant="subtitle1">Set a due date</Typography>
         <Typography variant="caption">Specify when this proposal should be accepted by.</Typography>

         <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={6}>
               <DueDate />
            </Grid>
            <Grid size={6}>
               <DueDateDate />
            </Grid>
         </Grid>
      </>
   );
})

const DueDate = observer(function DueDate() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   return proposalsEditDetailsStore.formHandler.dueDate.bindInput(ip =>
      <AutocompleteSingleNonClearable
         {...ip}
         variant='outlined'
         label="Due date"
         helperText={proposalsEditDetailsStore.dueDateHelperText}
         options={proposalsEditDetailsStore.dueDateOptions}
      />
   )
})

const DueDateDate = observer(function DueDateDate() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()

   if (proposalsEditDetailsStore.fields.dueDate !== 'specific-date') {
      return null
   }

   return proposalsEditDetailsStore.formHandler.dueDateDate.bindInput(ip =>
      <DatePicker disablePast
         withTime={false}
         clearable
         fullWidth
         label="Date"
         {...ip}
      />
   )
})
